export default "__VITE_ASSET__7123a91c__"